const toDash = str => str.split(/(?=[A-Z])/).join('-').toLowerCase()

export { 
    toDash
}